module.exports = __webpack_public_path__ + "media/audio_1.2ab3292b.mp3";